import React from 'react';
import { useTranslation } from 'react-i18next';
import ServiceDetailsHeader from './ServiceDetailsHeader';
import ServiceDescription from './ServiceDescription';
import ServiceSeoLandings from './ServiceSeoLandings';
import ServiceFeatures from './ServiceFeatures';
import ServicePortfolio from './ServicePortfolio';
import ServiceNestedAccordion from './ServiceNestedAccordion';
import DynamicPricingPlans from './DynamicPricingPlans';
import './ServiceDetails.css';

const ServiceDetails = ({ service, openAccordion, onToggleAccordion, accordionRef }) => {
  const { t } = useTranslation();
  return (
    <div className="service-details">
      <ServiceDetailsHeader service={service} />
      <div className="service-details-content">
        <ServiceDescription service={service} />

        <ServiceSeoLandings service={service} />

        {!!service.features?.length && (
          <ServiceFeatures features={service.features} title={service.featuresTitle} />
        )}

        {service.details && (
          <div className="service-details-section">
            <h3 className="service-details-section-title">{service.detailsTitle || t('serviceUi.details.fullDescription')}</h3>
            <p className="service-details-full-text">{service.details}</p>
          </div>
        )}

        {!!service.accordionItems?.length && (
          <ServiceNestedAccordion
            ref={accordionRef}
            items={service.accordionItems}
            openAccordion={openAccordion}
            onToggle={onToggleAccordion}
          />
        )}

        {!!service.planGroups?.some((group) => group.mode === 'request' || group.plans?.length) && (
          <DynamicPricingPlans service={service} />
        )}

        {(!!service.works?.filter((work) => work.isActive !== false).length || !!service.portfolioGallery?.length) && (
          <ServicePortfolio works={service.works} gallery={service.portfolioGallery} title={service.portfolioTitle} serviceId={service.legacyId} />
        )}
      </div>
    </div>
  );
};

export default ServiceDetails;
